import { render, staticRenderFns } from "./creditreport.vue?vue&type=template&id=36a24c71&scoped=true"
import script from "./creditreport.vue?vue&type=script&lang=js"
export * from "./creditreport.vue?vue&type=script&lang=js"
import style0 from "./creditreport.vue?vue&type=style&index=0&id=36a24c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a24c71",
  null
  
)

export default component.exports